import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { ProductSummary } from '../../interfaces/Product/ProductSummary';
import { getProducts } from '../../api/Product';

interface ProductSlugsDropdownProps {
  label?: string;
  productSlugs: string[];
  onChange: (slugs: string[]) => void;
  disabled?: boolean;
}

export const ProductSlugsDropdown = (props: ProductSlugsDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<ProductSummary[]>([]);

  useEffect(() => {
    setLoading(true);
    getProducts({
      page: 0,
      pageSize: 1_000_000,
      search: '',
      includeInactives: true,
      order: 'asc',
      orderBy: 'name',
    })
      .then((res) => setProducts(res.data))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Autocomplete
        multiple
        disableCloseOnSelect
        limitTags={2}
        size='small'
        disabled={props.disabled}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant='outlined'
            fullWidth
          />
        )}
        options={products}
        getOptionLabel={(product) => product.name}
        onChange={(_, selectedProducts) =>
          props.onChange(selectedProducts.map((product) => product.slug))
        }
        value={products.filter((product) =>
          props.productSlugs.includes(product.slug),
        )}
      />
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
